import React, { useContext, useEffect } from 'react'
import { Router } from 'react-router-dom'
import { LOCATION_CHANGE } from 'react-router-redux'
import { ReactReduxContext } from 'react-redux'
import history from './history'

let ConnectedRouter = React.memo((props) => {
  const { store } = useContext(ReactReduxContext)
  useEffect(() => {
    let unsubscribeFromHistory = history.listen(handleLocationChange)
    handleLocationChange(history.location)

    function handleLocationChange (location) {
      store.dispatch({
        type: LOCATION_CHANGE,
        payload: location
      })
    }

    return () => {
      if (unsubscribeFromHistory) unsubscribeFromHistory()
    }
  }, [store])

  return <Router {...props} />
})

export default ConnectedRouter



// WEBPACK FOOTER //
// ./src/utils/ConnectedRouter.js